import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import SEO from './components/seo/SEO';
import Home from './pages/Home';
import Services from './pages/Services';
import Hydraulics from './pages/Hydraulics';
import Gearboxes from './pages/Gearboxes';
import IndustrialRepair from './pages/IndustrialRepair';
import About from './pages/About';
import Industries from './pages/Industries';
import Equipment from './pages/Equipment';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import { trackPageView } from './utils/analytics';

const routeAnimationDuration = 180;

function AnimatedRoutes() {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [stage, setStage] = useState('enter');

  useEffect(() => {
    const currentPath = `${displayLocation.pathname}${displayLocation.search}`;
    const nextPath = `${location.pathname}${location.search}`;

    if (nextPath === currentPath) {
      return undefined;
    }

    setStage('exit');

    const swapTimer = window.setTimeout(() => {
      setDisplayLocation(location);
      setStage('enter');
    }, routeAnimationDuration);

    return () => window.clearTimeout(swapTimer);
  }, [displayLocation, location]);

  return (
    <div className={`page-transition page-transition--${stage}`}>
      <SEO pathname={displayLocation.pathname} />
      <Routes location={displayLocation}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/hydraulics" element={<Hydraulics />} />
        <Route path="/services/gearboxes" element={<Gearboxes />} />
        <Route path="/services/industrial-repair" element={<IndustrialRepair />} />
        <Route path="/about" element={<About />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/equipment" element={<Equipment />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/request-quote" element={<Navigate to="/contact" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <div className="site-shell">
        <AnalyticsTracker />
        <Header />
        <main id="main-content" className="page-content">
          <AnimatedRoutes />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
